<template>
  <v-timeline-item
    dot-color="userActivity"
    icon="mdi-import"
    fill-dot
  >
    <v-expansion-panels
      class="expansion-panels"
      variant="accordion"
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-title>
          <v-row
            no-gutters
            align="center"
            class="d-flex justify-center"
            :class="{ 'flex-column': $vuetify.display.smAndDown }"
          >
            <v-col md="8">
              <div class="mb-2 text-subtitle-1">
                {{ $t('lead-timeline.crm-lead-imported.title', { readableCrmName }) }}
              </div>
              <div class="text-grey">
                {{ $t('lead-timeline.crm-lead-imported.subtitle') }}
              </div>
            </v-col>
            <v-col
              class="pr-2 text-right text-grey"
              :class="{ 'text-start mt-2': $vuetify.display.smAndDown }"
              md="4"
            >
              {{ formatDate(data.createdAt) }}
            </v-col>
          </v-row>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-row>
            <v-col cols="12">
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title> {{ $t('labels.contact') }}: </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ name }}
                  </div>
                  <div class="text-grey text--darken-3 text-body-2">
                    <span> {{ phone }} </span>
                  </div>
                  <div class="text-grey text--darken-3 text-body-2">
                    <span> {{ email }} </span>
                  </div>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-timeline-item>
</template>

<script>
import crmMixin from '@/mixins/crm'

export default {
  mixins: [crmMixin],
  props: {
    data: { type: Object, default: null },
  },
  computed: {
    changes() {
      return this.data.details.changes
    },
    name() {
      return this.changes?.after?.name
    },
    phone() {
      return this.changes?.after?.phone
    },
    email() {
      return this.changes?.after?.email
    },
  },
}
</script>

<style scoped>
.expansion-panels {
  margin: -24px -24px 0 -24px;
}
</style>
